import {Injectable} from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {LoggedUserPersistRequest} from "../model/requests/logged-user-persist-request";
import {Observable} from "rxjs";
import {Organization} from "../model/organization";

@Injectable({
  providedIn: 'root'
})
export class AccountService {

  private readonly accountURL: string;


  constructor(private http: HttpClient) {
    this.accountURL = '/api/account';
  }

  public getLoggedUser(): Observable<any> {
    return this.http.get<any>(this.accountURL);
  }

  public getOrganizationOfLoggedUser(): Observable<{ organization: Organization }> {
    const url: string = `${this.accountURL}/organization`;
    return this.http.get<{ organization: Organization }>(url);
  }

  public editLoggedUser(userData: LoggedUserPersistRequest): Observable<any> {
    return this.http.put<any>(this.accountURL, userData);
  }

  public getUserSubscriptions(): Observable<any> {
    const url: string = `${this.accountURL}/subscriptions`;
    return this.http.get<any>(url);
  }

}
